export const lng = {
  lng: (state = '', action) => state,
};

export const dummy = (state = {}, action) => state;
